import PropTypes from 'prop-types'
import classNames from 'classnames'
import BaseBreadcrumb from '../../../breadcrumb'

import { KIND_LABEL_PLURAL_MAP, KIND_PATH_MAP } from '../../constants'

const Breadcrumb = ({ resourceKind, linkToKind = false, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'relative',
      'pb-20'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <BaseBreadcrumb
        items={[
          {
            text: 'Centro de recursos',
            href: linkToKind && KIND_PATH_MAP[resourceKind]
              ? `/recursos/${KIND_PATH_MAP[resourceKind]}`
              : '/recursos/'
          },
          {
            text: KIND_LABEL_PLURAL_MAP[resourceKind]
          }
        ]} />
    </div>
  </section>
}

Breadcrumb.propTypes = {
  resourceKind: PropTypes.string,
  linkToKind: PropTypes.bool
}

export default Breadcrumb
